import { removeDupes, cleanObject } from '../utils/helpers';

const connectedCalendars = (state = {
    items: [],
    fetchInfo: {
        user: {}
    }
}, action) => {
    if (action.error) {
        return state;
    }

    switch (action.type) {
        case 'TEAM_CHANGE':
        case 'RESET_STORE':
            return {
                items: [],
                fetchInfo: {
                    user: {}
                }
            };

        case 'MARK_ALL_FOR_REFETCH':
            return Object.assign({}, state, {
                items: [...state.items.map(item => ({
                    ...item,
                    shouldRefetch: true
                }))]
            });

        case 'CONNECTED_CALENDARS_FETCH_REQUESTED':
            return Object.assign({}, state, {
                fetchInfo: {
                    ...state.fetchInfo,
                    user: {
                        ...state.fetchInfo.user,
                        loading: true
                    }
                }
            });

        case 'CONNECTED_CALENDARS_FETCH_SUCCEEDED':
            if (!action.payload.calendars) {
                return state;
            }

            return Object.assign({}, state, {
                items: removeDupes([
                    ...action.payload.calendars,
                    ...state.items
                ], props => props.provider + props.calendarId + props.type),
                fetchInfo: {
                    ...state.fetchInfo,
                    user: {
                        loading: false,
                        fetched: true,
                        error: false
                    }
                }
            });

        case 'CONNECTED_CALENDARS_FETCH_FAILED':
            return Object.assign({}, state, {
                items: removeDupes([
                    ...action.payload.calendars,
                    ...state.items
                ], props => props.provider + props.calendarId + props.type),
                fetchInfo: {
                    ...state.fetchInfo,
                    user: {
                        loading: false,
                        fetched: true,
                        error: true
                    }
                }
            });

        case 'CONNECTED_CALENDARS_ADD_REQUESTED':
        case 'CONNECTED_CALENDARS_ADD_SOCKET':
            return Object.assign({}, state, {
                items: removeDupes([...state.items, ...action.payload.calendars], props => props.provider + props.calendarId + props.type)
            });

        case 'CONNECTED_CALENDARS_ADD_FAILED':
            return Object.assign({}, state, {
                items: state.items.filter(calendar => calendar !== action.payload.fragment)
            });


        case 'CONNECTED_CALENDARS_REMOVE_REQUESTED':
        case 'CONNECTED_CALENDARS_REMOVE_SOCKET':
            return Object.assign({}, state, {
                items: state.items
                    .filter(calendar => !action.payload.calendars
                        .some(({ calendarId, provider, type }) => calendar.provider === provider && calendar.calendarId === calendarId && calendar.type === type)
                    )
            });

        default:
            return state;
    }
}

export default connectedCalendars;
